import React, { useState } from 'react'
import ButtonIconSquare, { VARIANTS } from '@/modules/base/components/buttons/icon-square/button-icon-square'
import lang from '@/lang'
import EconomicAssetDrawer from '../drawer/economicAsset-drawer'
import EconomicAssetDetailView from '../drawer/economicAsset-detail-view'

const EconomicAssetFromExpenseOrRevenue = (props) => {
  const { id } = props
  const [economicAssetId, setEconomicAssetId] = useState(id)
  const [open, setOpen] = useState(false)

  const openEconomicAsset = () => {
    setEconomicAssetId(economicAssetId)
    setOpen(true)
  }
  const onCloseEditDrawer = () => {
    setOpen(false)
  }

  return (
    <>
      <ButtonIconSquare
        variant={VARIANTS.outline}
        label={lang.economicAsset.preview.economicAssetButtonTitle}
        onClick={openEconomicAsset}
      />
      <EconomicAssetDrawer open={open} onClose={onCloseEditDrawer} enableBackdropClick={true}>
        <EconomicAssetDetailView
          isExpense={true}
          economicAssetId={economicAssetId}
          onClose={onCloseEditDrawer}
          onAbort={onCloseEditDrawer}
        />
      </EconomicAssetDrawer>
    </>
  )
}

export default EconomicAssetFromExpenseOrRevenue
